module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expect-job"
  }, [_c('basic-info'), _vm._v(" "), _c('job-intention', {
    ref: "intention"
  }), _vm._v(" "), _c('privacy-setting'), _vm._v(" "), _c('div', {
    staticClass: "basic-info-save-box"
  }, [_c('div', {
    staticClass: "page-btn",
    class: {
      'btn-disabled': !_vm.expectionInfoOk
    },
    on: {
      "click": _vm.saveResumeEvent
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))]), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7f305c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/index.vue
// module id = 343
// module chunks = 0